import clsx from 'clsx';
import React from 'react';

import BaseButtonWithLoadingState from 'components/digifi-wrappers/ButtonWithLoadingState';
import { ButtonWithLoadingStateProps } from 'product_modules/components/ButtonWithLoadingState';

import styles from './Button.module.scss';
const ButtonWithLoadingState = ({ className, ...props }: ButtonWithLoadingStateProps) => {
  return <BaseButtonWithLoadingState {...props} className={clsx(styles.button, className)} />;
};

export default ButtonWithLoadingState;
